// extracted by mini-css-extract-plugin
module.exports = {"btnFAQ":"LegalIntro-module_btnFAQ","anchor":"LegalIntro-module_anchor","frequentQuestionsContainer":"LegalIntro-module_frequentQuestionsContainer"};